import React from 'react';
const beforeList = ['Stress continuo prima delle classi', 'Programmazioni casuali', 'Sempre gli stessi esercizi', 'Classi poco coinvolgenti', 'Caos nella gestione clienti', 'Burnout mentale'];
const afterList = ['Workout pronti in pochi minuti', 'Struttura professionale', 'Nuove idee ogni settimana', 'Experience premium', 'Sistema organizzato', 'Più energia e controllo'];
const bottomStats = [{
  num: '+180h',
  label: "Risparmiate all'anno",
  icon: '⏱️'
}, {
  num: '2 clic',
  label: 'Workout pronti',
  icon: '🔥'
}, {
  num: 'Premium',
  label: 'Professionalità percepita',
  icon: '📈'
}, {
  num: '💪',
  label: 'Classi più coinvolgenti',
  icon: '💪'
}, {
  num: '⚡',
  label: 'Più energia per allenare',
  icon: '⚡'
}, {
  num: '🏆',
  label: 'Più clienti soddisfatti',
  icon: '🏆'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-60">
      <div className="absolute top-20 -left-20 w-[400px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-61"></div>
      <div className="absolute bottom-20 -right-20 w-[400px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none" data-id="element-62"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-63">
        <div className="text-center mb-14" data-id="element-64">
          <span className="inline-flex items-center gap-2 bg-primary/15 border border-primary/40 text-primary font-bold uppercase tracking-[0.2em] text-xs sm:text-sm px-4 py-1.5 rounded-sm mb-5" data-id="element-65">
            <span data-id="element-66">⚡</span> La Trasformazione
          </span>
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-4 tracking-tight leading-[1.1] uppercase" data-id="element-67">
            Da coach stressato e disorganizzato…
          </h2>
          <p className="font-display text-2xl sm:text-4xl font-bold uppercase tracking-tight" data-id="element-68">
            a <span className="text-primary" data-id="element-69">professionista premium</span> con
            un sistema pronto all'uso.
          </p>
        </div>

        {/* Cost of inaction hero stat */}
        <div className="relative bg-gradient-to-br from-badge-red/15 via-badge-red/8 to-transparent border border-badge-red/30 rounded-sm p-8 sm:p-10 mb-16 overflow-hidden" data-id="element-70">
          <div className="absolute top-0 right-0 text-[160px] sm:text-[260px] leading-none opacity-[0.06] select-none -translate-y-6 translate-x-4 pointer-events-none" data-id="element-71">
            ⏳
          </div>
          <div className="relative grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-6 sm:gap-10 items-center" data-id="element-72">
            <div className="text-center sm:text-left flex-shrink-0" data-id="element-73">
              <p className="font-display text-badge-red font-bold text-6xl sm:text-8xl leading-none tracking-tighter" data-id="element-74">
                180+
              </p>
              <p className="text-badge-red font-bold text-sm sm:text-base uppercase tracking-[0.2em] mt-2" data-id="element-75">
                ore all'anno
              </p>
            </div>
            <div className="h-px sm:h-24 sm:w-px bg-badge-red/30 mx-auto" data-id="element-76"></div>
            <div className="text-white text-base sm:text-lg font-medium leading-relaxed" data-id="element-77">
              <span className="text-badge-red font-bold uppercase text-xs sm:text-sm tracking-[0.2em] block mb-3" data-id="element-78">
                Il costo reale di non agire
              </span>
              <p className="mb-3" data-id="element-79">Passate a:</p>
              <ul className="text-text-sec space-y-1 mb-3 text-sm sm:text-base" data-id="element-80">
                <li data-id="element-81">• cercare idee online</li>
                <li data-id="element-82">• improvvisare workout</li>
                <li data-id="element-83">• salvare reel Instagram</li>
                <li data-id="element-84">• copiare esercizi casuali</li>
                <li data-id="element-85">• creare classi all'ultimo minuto</li>
              </ul>
              <p data-id="element-86">
                È praticamente{' '}
                <span className="font-display text-badge-red font-bold uppercase" data-id="element-87">
                  un mese intero della tua vita
                </span>{' '}
                perso a programmare.
              </p>
            </div>
          </div>
        </div>

        {/* Before / After */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 mb-14" data-id="element-88">
          <div className="relative bg-bg-alt border border-badge-red/30 rounded-sm p-6 sm:p-8 overflow-hidden" data-id="element-89">
            <div className="absolute top-0 left-0 w-full h-1 bg-badge-red" data-id="element-90"></div>
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-border-light" data-id="element-91">
              <span className="w-10 h-10 rounded-sm bg-badge-red/15 border border-badge-red/40 flex items-center justify-center text-badge-red font-bold text-xl" data-id="element-92">
                ✕
              </span>
              <h3 className="font-display text-badge-red font-bold uppercase tracking-wider text-sm sm:text-base" data-id="element-93">
                Senza Functional Pronto
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-94">
              {beforeList.map((item, i) => <li key={i} className="flex items-start gap-3 text-text-sec text-sm sm:text-base" data-id="element-95">
                  <span className="text-badge-red flex-shrink-0 mt-1" data-id="element-96">▸</span>
                  <span data-id="element-97">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="relative bg-bg-alt border border-primary/50 rounded-sm p-6 sm:p-8 overflow-hidden shadow-[0_0_30px_-10px_rgba(242,92,37,0.3)]" data-id="element-98">
            <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-99"></div>
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-border-light" data-id="element-100">
              <span className="w-10 h-10 rounded-sm bg-primary/15 border border-primary/40 flex items-center justify-center text-primary font-bold text-xl" data-id="element-101">
                ✓
              </span>
              <h3 className="font-display text-primary font-bold uppercase tracking-wider text-sm sm:text-base" data-id="element-102">
                Con Functional Pronto
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-103">
              {afterList.map((item, i) => <li key={i} className="flex items-start gap-3 text-white text-sm sm:text-base font-medium" data-id="element-104">
                  <span className="text-primary flex-shrink-0 mt-1" data-id="element-105">▸</span>
                  <span data-id="element-106">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom victory stats */}
        <div data-id="element-107">
          <p className="text-center text-primary font-display text-sm sm:text-base font-bold uppercase tracking-[0.2em] mb-7" data-id="element-108">
            ✨ Il risultato netto
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-5" data-id="element-109">
            {bottomStats.map((s, i) => <div key={i} className="relative bg-bg-alt border border-border-light rounded-sm p-5 text-center overflow-hidden hover:border-primary/40 transition-colors group" data-id="element-110">
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent opacity-60" data-id="element-111"></div>
                <div className="text-2xl sm:text-3xl mb-2" data-id="element-112">{s.icon}</div>
                <p className="font-display text-primary font-bold text-lg sm:text-2xl mb-1 tracking-tight" data-id="element-113">
                  {s.num}
                </p>
                <p className="text-text-sec text-xs sm:text-sm leading-snug font-medium" data-id="element-114">
                  {s.label}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}